import Spinner from 'src/javascripts/components/utilities/Spinner';
import {filterTypeahead} from 'src/javascripts/components/typeaheads/TypeaheadBloodhounds';
import {noResultsTemplate, genericDisplayTemplate} from 'src/javascripts/components/typeaheads/TypeaheadTemplates';
import 'src/javascripts/vendor/typeahead.jquery';
import 'src/javascripts/vendor/bloodhound';

// Must define Bloodhound explicitly here
// https://stackoverflow.com/questions/30750916/how-to-reference-typeahead-and-bloodhound-when-loading-npm-typeahead-js
const Bloodhound = require('src/javascripts/vendor/bloodhound');

export default class SurveysQuestionsFormStepThree {

  constructor() {}

  render() {
    let accountUrl = $('body').attr('data-account-url');
    let surveySlug = $('.validating-questions-search').attr('data-slug');
    let eqUrl = "/" + accountUrl + "/surveys/questions";
    let params = {};
    if (typeof surveySlug !== 'undefined') {params['survey_id'] = surveySlug;}

    // DROPDOWN ANSWER FORMAT //

    // Display or hide dropdown options based on question type selected
    $('#survey_question_question_type').change(function() {
      let val = $(this).val();
      if ((val === "Dropdown") || (val === "Dropdown Multiselect")) {
        $('.dropdown-options-section').removeClass('d-none');
        $('.dropdown-options-list').removeClass('d-none');
      } else {
        $('.dropdown-options-section').addClass('d-none');
        $('.dropdown-options-list').addClass('d-none');
      }
    })

    // Display or hide decimals allowed based on question type
    let toggleDecimalsAllowed = function(val) {
      if (val === 'Decimal' || val === 'USD') {
        $('#decimalsAllowed').removeClass('d-none');
      } else {
        $('#decimalsAllowed').addClass('d-none');
      }
    }

    let questionTypeInput = $('#survey_question_question_type');
    toggleDecimalsAllowed(questionTypeInput.val());
    questionTypeInput.change(function() {
      toggleDecimalsAllowed($(this).val());
    });    

    // Dropdown options row
    let optRow = function(i, val = '') {
      let template = "<div class='row'>";
      template += "<label class='col-6 col-form-label'>Option " + i + "</label>";
      template += "<div class='col-6'>";
      template += "<div class='option-text-row h5 mb-2 py-1'>";
      template += "<div class='d-flex align-items-center w-100'>";
      template += "<input class='form-control font-weight-light mr-2 option-text-field' id='" + i + "_option_text' type='text' value='" + val + "' name='survey_question[question_options_attributes][" + i + "][option_text]' data-lpignore='true' autocomplete='off'>";
      template += "<div class='btn btn-white delete-new-option' data-title='Remove option' data-toggle='tooltip' data-original-title='' title=''>";
      template += "<svg width='14' height='16' viewBox='0 0 14 16' fill='none' xmlns='http://www.w3.org/2000/svg'>";
      template += "<g id='Icon Right'>";
      template += "<path id='Vector' d='M4.2 3.79989V2.39989C4.2 1.88442 4.61787 1.46655 5.13333 1.46655H8.86667C9.38213 1.46655 9.8 1.88442 9.8 2.39989V3.79989M0.875 4.26655H13.125M2.275 4.26655V13.5999C2.275 14.1154 2.69287 14.5332 3.20833 14.5332H10.7917C11.3071 14.5332 11.725 14.1154 11.725 13.5999V4.26655M7 7.12489V11.8499M5.075 7.12489V11.8499M8.925 7.12489V11.8499' stroke='#DA3547' stroke-linecap='round' stroke-linejoin='round'></path>";
      template += "</g></svg></div></div></div></div></div>";
      return template
    }

    // Add one option
    $('#addQuestionOption').click(function() {
      let i = $('.options .row').length + 1;
      let r = optRow(i);
      $('.options').append(r);
      $('.delete-new-option').off().on('click', function() {
        $('[data-toggle=tooltip]').tooltip('hide');
        $(this).closest('.row').remove();
      });
    })

    // On select of dropdown type
    $('#survey_question_options_source').change(function() {
      let optsList;
      let val = $(this).val();
      $('.options .row').remove();
      if (val === "Countries") {
        optsList = JSON.parse($(this).attr('data-countries'));
      } else if (val === "SASB Industries") {
        optsList = JSON.parse($(this).attr('data-sasb'));
      } else if (val === "Yes / No") {
        optsList = JSON.parse($(this).attr('data-yn'));
      } else if (val === "Yes / No / NA") {
        optsList = JSON.parse($(this).attr('data-yna'));
      }
      if (typeof optsList !== 'undefined') {
        $.each(optsList, function(k,v) {
          let r = optRow(k + 1,v);
          $('.options').append(r);
        })
      } else {
        let r = optRow(1);
        $('.options').append(r);
      }
      $('.delete-new-option').off().on('click', function() {
        $('[data-toggle=tooltip]').tooltip('hide');
        $(this).closest('.row').remove();
      });
    })

    // VALIDATIONS //

    // Display validations on select
    $('#has_validations').change(function() {
      if ($(this).is(':checked')) {
        $('.validations-section').removeClass('d-none');
      } else {
        $('.validations-section').addClass('d-none');        
      }
    })

    // Use specific value or existing question value
    let valButtons = function() {
      $('.validations-buttons .btn').off().on('click', function() {
        let t = $(this).attr('data-type');
        let g = $(this).closest('.validations-buttons');
        g.find('.btn').removeClass('btn-active').addClass('btn-light');
        $(this).closest('.row').find('.validation-value-type').val(t);
        $(this).addClass('btn-active').removeClass('btn-light');
        if (t === 'specific_value') {
          $(this).closest('.row').find('.specific-value').removeClass('d-none');
          $(this).closest('.row').find('.existing-question').addClass('d-none');
        } else {
          $(this).closest('.row').find('.specific-value').addClass('d-none');
          $(this).closest('.row').find('.existing-question').removeClass('d-none');
          $(this).closest('.row').find('.validating-questions-search').focus();
        }
      })
    }
    valButtons();

    // On selecting an existing question
    let onSelectExisting = function() {
      $('.validating-questions-search').bind('typeahead:beforeselect typeahead:autocomplete', function(ev, suggestion) {
        let r = $(this).closest('.row')
        r.find('.validating-question-id').val(suggestion.record_id);
      });
    }
    onSelectExisting();

    // Validation row
    let validationRow = function(i, val = '') {
      let template = "<div class='row'>";
      template += "<label class='col-6 col-form-label'>Validation " + i + "</label>"
      template += "<div class='col-6'>"
      template += "<div class='validation-text-row h5 mb-2 py-1'>"
      template += "<div class='d-flex w-100'>"
      template += "<input id='" + i + "_validation_id' type='hidden' name='survey_question[validations_attributes][" + i + "][id]' data-lpignore='true' autocomplete='off'>"
      template += "<input id='validating_question_id_" + i + "' class='validating-question-id' type='hidden' name='survey_question[validations_attributes][" + i + "][validating_question_id]' data-lpignore='true' autocomplete='off'>"
      template += "<div class='mr-2 w-100'>"
      template += "<input class='validation-value-type' id='validation_value_type_" + i + "' type='hidden' name='survey_question[validations_attributes][" + i + "][validation_value_type]' data-lpignore='true' autocomplete='off' value='specific_value'>"
      template += "<select class='form-control validation-field  mb-2' id='validation_operator_" + i + "' name='survey_question[validations_attributes][" + i + "][operator]'><option selected='selected' value='Greater than'>Greater than</option>"
      template += "<option value='Greater than or equal to'>Greater than or equal to</option>"
      template += "<option value='Equals'>Equals</option>"
      template += "<option value='Less than or equal to'>Less than or equal to</option>"
      template += "<option value='Less than'>Less than</option>"
      template += "<option value='Does not equal'>Does not equal</option>"
      template += "<option value='Min Length'>Min Length</option>"
      template += "<option value='Max Length'>Max Length</option></select>"
      template += "<div class='btn-group validations-buttons mb-2'>"
      template += "<div class='btn font-weight-normal btn-active' style='font-size: 13px;' data-type='specific_value'>"
      template += "Specific Value</div>"
      template += "<div class='btn font-weight-normal btn-light' style='font-size: 13px;' data-type='existing_question'>"
      template += "Existing Question</div></div>"
      template += "<div class='specific-value'>"
      template += "<input autocomplete='off' placeholder='Set value' class='form-control validation-field specific-value' id='validation_value_" + i + "' type='text' name='survey_question[validations_attributes][" + i + "][validation_value]' data-lpignore='true'>"
      template += "</div>"
      template += "<div class='existing-question d-none'>"
      template += "<textarea rows='4' name='questions' id='validating_questions_search_" + i + "' autocomplete='off' placeholder='Set a question' class='form-control clickable typeahead validating-questions-search' data-lpignore='true'></textarea>"
      template += "</div>"
      template += "</div>"
      template += "<div style='width: 50px;'>"
      template += "<div class='btn btn-white delete-new-validation' data-title='Remove validation' data-toggle='tooltip' data-original-title='' title=''>";
      template += "<svg width='14' height='16' viewBox='0 0 14 16' fill='none' xmlns='http://www.w3.org/2000/svg'>";
      template += "<g id='Icon Right'>";
      template += "<path id='Vector' d='M4.2 3.79989V2.39989C4.2 1.88442 4.61787 1.46655 5.13333 1.46655H8.86667C9.38213 1.46655 9.8 1.88442 9.8 2.39989V3.79989M0.875 4.26655H13.125M2.275 4.26655V13.5999C2.275 14.1154 2.69287 14.5332 3.20833 14.5332H10.7917C11.3071 14.5332 11.725 14.1154 11.725 13.5999V4.26655M7 7.12489V11.8499M5.075 7.12489V11.8499M8.925 7.12489V11.8499' stroke='#DA3547' stroke-linecap='round' stroke-linejoin='round'></path>";
      template += "</g></svg></div></div></div></div></div>";
      return template;
    }

    // Add one option
    $('#addQuestionValidation').click(function() {
      let i = $('.validations-section .validations .row').length + 1;
      let r = validationRow(i);
      $('.validations-section .validations').append(r);
      $('.delete-new-validation').off().on('click', function() {
        $('[data-toggle=tooltip]').tooltip('hide');
        $(this).closest('.row').remove();
      });
      valButtons();
      filterTypeahead('#validating_questions_search_' + i, 'questions', eqUrl + '?' + $.param(params), 446, 'generic');
      onSelectExisting();
    })

    // Destroy on click
    $('.remove-validation-x').click(function() {
      $(this).closest('.validation-row').find('input[type=\'hidden\']').val('true');
      $(this).closest('.validation-row').addClass('d-none');
    })

    // Search validations
    filterTypeahead('.validating-questions-search', 'questions', eqUrl + '?' + $.param(params), 446, 'generic');

    // CALCULATIONS //

    // Display validations on select
    $('#calculated').change(function() {
      if ($(this).is(':checked')) {
        $('.calculations-section').removeClass('d-none');
      } else {
        $('.calculations-section').addClass('d-none');        
      }
    })

    // On selecting an existing question
    let onSelectExistingCalc = function() {
      $('.calculation-questions-search').bind('typeahead:beforeselect typeahead:autocomplete', function(ev, suggestion) {
        let r = $(this).closest('.row')
        r.find('.calculation-question-id').val(suggestion.record_id);
      });
    }
    onSelectExistingCalc();

    // Calculation row
    let calculationRow = function(i, attrs = {}) {
      const {
        calculationId = '',
        determiningQuestionId = '',
        operator = 'Add',
        questionPlaceholder = 'Set a question',
        questionValue = '',
        surveyId = ''
      } = attrs;

      let template = "<div class='row'>";
      template += "<label class='col-6 col-form-label'>Calculation " + i + "</label>";
      template += "<div class='col-6'>";
      template += "<div class='calculation-text-row h5 mb-2 py-1'" + (calculationId ? " data-calculation-id='" + calculationId + "' id='calculation_text_row_" + calculationId + "'" : '') + ">";
      template += "<div class='d-flex w-100'>";
      template += "<input id='" + i + "_calculation_id' type='hidden' name='survey_question[dependent_calculations_attributes][" + i + "][id]'" + (calculationId ? " value='" + calculationId + "'" : '') + " data-lpignore='true' autocomplete='off'>";
      template += "<input id='calculation_question_id_" + i + "' class='calculation-question-id' type='hidden' name='survey_question[dependent_calculations_attributes][" + i + "][determining_question_id]'" + (determiningQuestionId ? " value='" + determiningQuestionId + "'" : '') + " data-lpignore='true' autocomplete='off'>";
      template += "<div class='mr-2 w-100'>";
      template += "<select class='form-control calculation-field  mb-2' id='calculation_operator_" + i + "' name='survey_question[dependent_calculations_attributes][" + i + "][operator]'>";
      ['Add','Subtract','Multiply','Divide'].forEach(opt => {
        template += "<option value='" + opt + "'" + (operator === opt ? " selected='selected'" : '') + ">" + opt + "</option>";
      });
      template += "</select>";
      template += "<span class='twitter-typeahead' style='position: relative; display: inline-block;'>";
      template += "<textarea autocomplete='off' class='form-control clickable typeahead calculation-questions-search tt-hint' rows='4' readonly spellcheck='false' tabindex='-1' dir='ltr' style='position: absolute; top: 0px; left: 0px; border-color: transparent; box-shadow: none; opacity: 1; background: none 0% 0% / auto repeat scroll padding-box padding-box rgb(255, 255, 255);'>" + (questionValue || '') + "</textarea>";
      template += "<textarea name='questions' id='calculation_questions_search_" + i + "' autocomplete='off' placeholder='" + questionPlaceholder + "' class='form-control clickable typeahead calculation-questions-search tt-input'" + (surveyId ? " data-survey-id='" + surveyId + "'" : '') + " rows='4' spellcheck='false' dir='auto' style='position: relative; vertical-align: top; background-color: transparent;'>" + (questionValue || '') + "</textarea>";
      template += "<pre aria-hidden='true' style='position: absolute; visibility: hidden; white-space: pre;'></pre>";
      template += "<div class='menu-container' style='position: absolute; top: 110%; left: 0px; z-index: 100; display: none;'><div class='tt-dataset tt-dataset-questions'></div></div>";
      template += "</span>";
      template += "</div>";
      template += "<div style='width: 50px;'>";
      template += "<div class='btn btn-white delete-new-calculation' data-title='Remove calculation' data-toggle='tooltip' data-original-title='' title=''>";
      template += "<svg width='14' height='16' viewBox='0 0 14 16' fill='none' xmlns='http://www.w3.org/2000/svg'>";
      template += "<g id='Icon Right'>";
      template += "<path id='Vector' d='M4.2 3.79989V2.39989C4.2 1.88442 4.61787 1.46655 5.13333 1.46655H8.86667C9.38213 1.46655 9.8 1.88442 9.8 2.39989V3.79989M0.875 4.26655H13.125M2.275 4.26655V13.5999C2.275 14.1154 2.69287 14.5332 3.20833 14.5332H10.7917C11.3071 14.5332 11.725 14.1154 11.725 13.5999V4.26655M7 7.12489V11.8499M5.075 7.12489V11.8499M8.925 7.12489V11.8499' stroke='#DA3547' stroke-linecap='round' stroke-linejoin='round'></path>";
      template += "</g></svg>";
      template += "</div></div></div></div></div>";
      return template;
    }

    // Add one calculation
    $('#addQuestionCalculation').click(function() {
      let i = $('.calculations-section .calculations .row').length;
      let r = calculationRow(i);
      $('.calculations-section .calculations').append(r);
      $('.delete-new-calculation').off().on('click', function() {
        $('[data-toggle=tooltip]').tooltip('hide');
        $(this).closest('.row').remove();
      });
      filterTypeahead('#calculation_questions_search_' + i, 'questions', eqUrl + '?' + $.param(params), 446, 'generic');
      onSelectExistingCalc();
    })

    // Destroy on click
    $('.remove-calculation-x').click(function() {
      $(this).closest('.calculation-row').find('input[type=\'hidden\']').val('true');
      $(this).closest('.calculation-row').addClass('d-none');
    })

    // Search validations
    filterTypeahead('.calculation-questions-search', 'questions', eqUrl + '?' + $.param(params), 446, 'generic');




  }
}
